<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Access Anna's Archive</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form (ngSubmit)="onLogin()" #loginForm="ngForm">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Access Code</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="code"
            name="code"
            required
            placeholder="Enter your access code"
            autocomplete="off"
            [disabled]="loading"
          />
        </mat-form-field>

        <div *ngIf="error" class="error-message">
          {{ error }}
        </div>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="full-width login-button"
          [disabled]="loading || !loginForm.valid"
        >
          {{ loading ? 'Signing in...' : 'Sign In' }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
